<template>
    <v-layout
      text-xs-center
      wrap
      v-if="attendee"
    >
      <v-flex mt-2 >
	    <v-btn :to="`/events/${this.$route.params.event_id}`">Event Home</v-btn>
      </v-flex>
      <v-flex my-2 xs12 text-xs-center>
            <h2>My Ticket(s)</h2>
            <div v-if="false">
                Able To Attend Event? {{attendee.active}}
            </div>
      </v-flex>
      <v-flex my-2 xs12 v-if="attendee.room_allocation">
            <h2>Room Allocation</h2>
            <v-flex>
            Team: {{ attendee.room_allocation.name }}
            </v-flex>
            <v-flex>
            Allocation: {{ attendee.room_allocation.allocation }}
            </v-flex>
      </v-flex>

      <v-flex my-2 xs12 text-xs-center>
            <div v-for="ticket in living_tickets" class="ticket">
                <div>
                  <b>Event Ticket #{{ticket.id}}</b>
                </div>
                <div v-for="teo in ticket.ticket_event_options" class="ticket_event_option">
                    With Option: {{ teo.event_option_name }}
                </div>
                <hr/>
                <h2>Transfer Ticket</h2>
                <v-btn v-if="transfer_restrictions.blocks.length > 0" disabled>Transfer Blocked</v-btn>
                <div v-if="transfer_restrictions.blocks.length == 0" >
                    <EventTicketTransfer :ticket="ticket" />
                </div>
                <br/>
                <div v-show="transfer_restrictions.weak.length > 0">
                    <b>Notes:</b>
                    <div v-for="reason in transfer_restrictions.weak">
                        {{ reason }}
                    </div>
                </div>
                <div v-show="transfer_restrictions.blocks.length > 0">
                    <b>Transfer Restricted Reasons:</b>
                    <div v-for="reason in transfer_restrictions.blocks">
                        {{ reason }}
                    </div>
                </div>
            </div>
      </v-flex>

    <hr/>
      <v-flex xs12 mb-4 v-if="false">
        <h2>Active Event Options</h2>
        <v-btn disabled>Add Options</v-btn>
        <br/>Coming Soon
      </v-flex>
    </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import EventTicketTransfer from './EventTicketTransfer';

export default {
  components: {EventTicketTransfer},
  data: () => ({
    ready: false,
  }),
  beforeMount: async function() {
    this.$store.dispatch('loadAttendees');
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees', 'event_teams']),
    attendee() {
      return this.attendees?.find(a => {
        return a.event_id == this.$route.params.event_id;
      });
    },
    living_tickets() {
      let a =  this.attendees?.find(a => {
        return a.event_id == this.$route.params.event_id;
      });
      return a.tickets.filter(t => {
          return !t.canceled_at 
      })
    },
    team_attendees() {
      return this.attendees?.find(a => {
        return a.event_id == this.$route.params.event_id;
      }).team_attendees;
    },
    transfer_restrictions() {
      return this.attendee?.transfer_info?.restrictions;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped>
.ticket {
  border: 1px solid grey;
  border-radius: 5px;
  margin-top: 1em;
  margin-left: 1em;
  margin-right: 1em;
  padding: 0.5em;
}
.ticket_event_option {
}
</style>
